import axiosIns from "@/api/axios";

export const GET_NOTIFICATIONS = (query) => {
  let url = "/notification-in-webs";

  if (query && Object.keys(query).length > 0) {
    const params = new URLSearchParams(query).toString();
    url += `?${params}`;
  }

  return axiosIns.get(url);
};

export const GET_COUNT_NOTIFICATION = () => {
  return axiosIns.get(`/notification-in-webs/count`);
};

export const MARK_AS_READ = (id) => {
  return axiosIns.put(`/notification-in-webs/${id}`);
};

export const MARK_ALL_AS_READ = () => {
  return axiosIns.put(`/notification-in-webs/read-all`);
};

export const GET_NOTIFICATION_TYPES = () => {
  return axiosIns.get(`/module-types?all=true`);
};
